import { ComputationOptions } from "shared";

export const computationOptions: ComputationOptions = {
  isTrueShapeNestingEnabled: import.meta.env.VITE_FF_TRUE_SHAPE_NESTING === "true",
};
